<template>
  <v-container>
    <v-row justify="space-between" no-gutters class="my-2">
      <v-btn exact text :to="{ name: 'PreparationSlipTemplateIndex' }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
      <v-btn
        v-if="id !== null"
        icon
        text
        v-show="!preparationSlipTemplate.is_deleted"
        @click="deletePreparationSlipTemplate"
      >
        <v-hover v-slot:default="{ hover }">
          <v-icon :color="hover ? 'error' : ''">fa-trash</v-icon>
        </v-hover>
      </v-btn>
      <v-btn
        v-if="id !== null"
        icon
        text
        v-show="preparationSlipTemplate.is_deleted"
        @click="restorePreparationSlipTemplate"
      >
        <v-hover v-slot:default="{ hover }">
          <v-icon :color="hover ? 'success' : ''">fa-trash-restore</v-icon>
        </v-hover>
      </v-btn>
    </v-row>
    <v-card class="mb-2">
      <v-card-text>
        <PreparationSlipTemplateFields
          v-bind.sync="preparationSlipTemplate"
          :valid.sync="valid"
        ></PreparationSlipTemplateFields>
      </v-card-text>
    </v-card>
    <PreparationSlipTemplateEditorGrid
      :items="products"
      :show-min="preparationSlipTemplate.sales_target !== null"
    ></PreparationSlipTemplateEditorGrid>
    <v-card class="mt-2">
      <v-card-text>
        <v-row dense no-gutters class="mb-2">
          <span class="overline primary--text">
            Instructions Supplémentaires</span
          >
        </v-row>
        <PreparationSlipInstructions
          v-if="preparationSlipTemplate.instructions !== undefined"
          ref="instructionsEditor"
          :instructions="preparationSlipTemplate.instructions"
        ></PreparationSlipInstructions>
      </v-card-text>
    </v-card>
    <v-row align="center" justify="end" no-gutters class="mt-3">
      <v-btn
        color="primary"
        @click="savePreparationSlipTemplate"
        :disabled="!valid"
        :block="$vuetify.breakpoint.xsOnly"
        :large="$vuetify.breakpoint.smAndDown"
      >
        <v-icon small left>fa-save</v-icon>
        Enregistrer
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import {
  PreparationSlipTemplateEditorGrid,
  PreparationSlipTemplateFields,
  PreparationSlipInstructions
} from "../components";
export default {
  name: "PreparationSlipTemplateEditor",
  props: {
    id: {
      required: false,
      default: null
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  components: {
    PreparationSlipTemplateEditorGrid,
    PreparationSlipTemplateFields,
    PreparationSlipInstructions
  },
  computed: {
    ...mapGetters([
      "getStoreId",
      "getIsAdmin",
      "getProducts",
      "getAllProducts",
      "getRecipes"
    ])
  },
  data() {
    return {
      preparationSlipTemplate: {
        name: "",
        comments: "",
        store: null,
        is_deleted: false,
        sales_target: null,
        instructions: undefined
      },
      valid: false,
      products: []
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        await this.$store.dispatch("loadAllRecipeStore");
        if (this.id === null) {
          this.preparationSlipTemplate.instructions = {
            time: Date.now(),
            blocks: [],
            version: "2.15.1"
          };
          this.products = [
            ...this.getProducts.filter(x => x.is_deleted === false)
          ].map(x => {
            return {
              ...x,
              quantity_min: null,
              quantity: 0,
              quantity_required: 0,
              quantity_required_recipe: 0,
              force_show: false
            };
          });
        } else {
          this.preparationSlipTemplate = await api.retrievePreparationSlipTemplate(
            this.id
          );
          if (this.preparationSlipTemplate.sales_target !== null) {
            this.preparationSlipTemplate.sales_target = Number(
              this.preparationSlipTemplate.sales_target
            );
          }
          this.products = [
            ...this.preparationSlipTemplate.preparation_slip_template_products
          ].map(x => {
            const originProduct = this.getAllProducts.find(
              p => p.id === x.fk_product
            );
            return {
              ...originProduct,
              quantity_min:
                x.quantity_min === null ? null : Number(x.quantity_min),
              quantity: Number(x.quantity),
              quantity_required: 0,
              quantity_required_recipe: 0,
              origin_quantity: Number(x.quantity),
              force_show: x.force_show,
              product_template_id: x.id
            };
          });
          const productNotInTemplate = this.getProducts
            .filter(x => x.is_deleted === false)
            .filter(x => this.products.find(p => p.id === x.id) === undefined);
          productNotInTemplate.map(x => {
            const d = {
              ...x,
              quantity_min: null,
              quantity: 0,
              quantity_required: 0,
              quantity_required_recipe: 0,
              origin_quantity: 0,
              force_show: false,
              product_template_id: null
            };
            this.products.push(d);
          });
        }
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async deletePreparationSlipTemplate() {
      if (this.id !== null) {
        try {
          this.$store.dispatch("slo");
          this.preparationSlipTemplate.is_deleted = true;
          await api.patchPreparationSlipTemplate(
            this.id,
            this.preparationSlipTemplate
          );
        } finally {
          this.$store.dispatch("elo");
        }
      }
    },
    async restorePreparationSlipTemplate() {
      if (this.id !== null) {
        try {
          this.$store.dispatch("slo");
          this.preparationSlipTemplate.is_deleted = false;
          await api.patchPreparationSlipTemplate(
            this.id,
            this.preparationSlipTemplate
          );
        } finally {
          this.$store.dispatch("elo");
        }
      }
    },
    async savePreparationSlipTemplate() {
      if (this.id === null) {
        //create
        const instructions = await this.$refs.instructionsEditor.save();
        const data = {
          ...this.preparationSlipTemplate,
          store: this.getStoreId,
          instructions: instructions
        };
        try {
          this.$store.dispatch("slo");
          const res = await api.postPreparationSlipTemplate(data);
          if (res) {
            const tasks = [];
            this.products.forEach(x => {
              const d = {
                fk_preparation_slip_template: res.id,
                fk_product: x.id,
                quantity_min: x.quantity_min,
                quantity: x.quantity,
                force_show: x.force_show,
                store: this.getStoreId
              };
              tasks.push(api.postPreparationSlipTemplateProduct(d));
            });
            await Promise.all(tasks);
            this.$router.push({ name: "PreparationSlipTemplateIndex" });
          }
        } finally {
          this.$store.dispatch("elo");
        }
      } else {
        //update
        const instructions = await this.$refs.instructionsEditor.save();
        const data = {
          ...this.preparationSlipTemplate,
          store: this.getStoreId,
          instructions: instructions
        };
        try {
          this.$store.dispatch("slo");
          const res = await api.patchPreparationSlipTemplate(this.id, data);
          if (res) {
            const tasks = [];
            this.products.forEach(x => {
              const d = {
                fk_preparation_slip_template: res.id,
                fk_product: x.id,
                quantity_min: x.quantity_min,
                quantity: x.quantity,
                force_show: x.force_show,
                store: this.getStoreId
              };
              if (x.product_template_id !== null) {
                d.id = x.product_template_id;
                tasks.push(api.patchPreparationSlipTemplateProduct(d.id, d));
              } else {
                tasks.push(api.postPreparationSlipTemplateProduct(d));
              }
            });
            await Promise.all(tasks);
            this.$router.push({ name: "PreparationSlipTemplateIndex" });
          }
        } finally {
          this.$store.dispatch("elo");
        }
      }
    }
  }
};
</script>

<style></style>
